import { PullRequest } from '../../models/PullRequest';

export type SelectReviewAction = {
  type: 'SECURITY/SELECT_REVIEW';
  pullRequest: PullRequest;
};

export type ClearSelectedReviewAction = {
  type: 'SECURITY/CLEAR_SELECTED_REVIEW';
};

export type SecurityAction = SelectReviewAction | ClearSelectedReviewAction;

export const actions = {
  selectReview: (pullRequest: PullRequest) => ({
    type: 'SECURITY/SELECT_REVIEW',
    pullRequest,
  }),
  clearSelectedReview: () => ({
    type: 'SECURITY/CLEAR_SELECTED_REVIEW',
  }),
};
